<template>
  <div class="f-col full home">
    <Welcome />
  </div>
</template>

<script>
import Welcome from "./Welcome";

export default {
  name: "Home",
  components: {
    Welcome,
  },
  async created() {
    try {
      this.$store.commit("TOGGLE_DISPLAY_LAYOUT", {
        menu: true,
        header: true,
        footer: true,
      });
      this.$store.dispatch("HOME_CONTEXT_REQUEST");
    } catch (err) {
      console.warn(err);
    }
  },
};
</script>

<style scoped>
.home {
  justify-content: flex-start;
  width: auto;
  height: 100%;
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>